import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import OnboardingHeader from './OnboardingHeader';
import { STEP_TO_PATH } from '../../context/OnboardingContext';

const FULL_BLEED_ROUTES = new Set([
  STEP_TO_PATH['lets-go'],
  STEP_TO_PATH['guidebooks-reveal'],
  STEP_TO_PATH['task-intro'],
  STEP_TO_PATH['sms-reveal'],
  STEP_TO_PATH['complete'],
]);

const isFullBleed = (pathname) => {
  const normalized = pathname.replace(/\/$/, '');
  return FULL_BLEED_ROUTES.has(normalized);
};

const HIDE_HEADER_ROUTES = new Set([
  STEP_TO_PATH['lets-go'],
  STEP_TO_PATH['guidebooks-reveal'],
  STEP_TO_PATH['task-intro'],
  STEP_TO_PATH['sms-reveal'],
  STEP_TO_PATH['complete'],
]);

const hideHeader = (pathname) => {
  const normalized = pathname.replace(/\/$/, '');
  return HIDE_HEADER_ROUTES.has(normalized);
};

const isLanding = (pathname) => {
  const normalized = pathname.replace(/\/$/, '');
  return normalized === '/onboarding' || normalized === '/onboarding/OB1';
};

const OnboardingShell = () => {
  const { pathname } = useLocation();
  const showNav = !isFullBleed(pathname);
  const headerHidden = hideHeader(pathname);
  const landingMode = isLanding(pathname);

  return (
    <div className={`hg-onboarding-shell${headerHidden ? ' hg-onboarding-shell--no-header' : ''}`}>
      {!headerHidden && <OnboardingHeader showNav={showNav} showHumanPill={landingMode} />}
      <div className="hg-onboarding-shell__outlet">
        <Outlet />
      </div>
    </div>
  );
};

export default OnboardingShell;
